import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp } from "lucide-react";
import api from "@/lib/api";

const Col = ({ title, children }) => (
  <div>
    <p className="font-display font-bold text-sm text-slate-900">{title}</p>
    <ul className="mt-3 space-y-2 text-sm text-slate-500">{children}</ul>
  </div>
);

const FLink = ({ to, children }) => (
  <li><Link to={to} className="hover:text-primary transition-colors">{children}</Link></li>
);

export default function Footer() {
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/meta").then((r) => setCategories(r.data.categories || [])).catch(() => {}); }, []);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-slate-200 bg-white">
      <button onClick={toTop} data-testid="footer-back-to-top"
        className="w-full bg-slate-50 text-slate-600 text-sm font-semibold py-3.5 hover:bg-slate-100 transition">
        <span className="inline-flex items-center gap-2"><ChevronUp className="h-4 w-4 text-primary" /> Back to top</span>
      </button>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <Col title="Get to Know Us">
          <FLink to="/">About MaterialXpress</FLink>
          <FLink to="/#advantages">Why firms switch</FLink>
          <FLink to="/#how">How fulfilment works</FLink>
          <FLink to="/#onboarding">Become a vendor</FLink>
        </Col>
        <Col title="Shop">
          <FLink to="/buyer">All materials</FLink>
          <FLink to="/buyer?express=1">Express-eligible</FLink>
          <FLink to="/cart">Your cart</FLink>
          <FLink to="/orders">Your orders</FLink>
        </Col>
        <Col title="Procurement Tools">
          <FLink to="/tools?tab=floorplan">Floor Plan → BOQ</FLink>
          <FLink to="/tools?tab=ai">AI Material Recommender</FLink>
          <FLink to="/tools?tab=calculator">Material Calculator</FLink>
          <FLink to="/tools?tab=bom">Bulk Order Builder</FLink>
        </Col>
        <Col title="Shop by Category">
          {categories.slice(0, 6).map((c) => <FLink key={c.id} to={`/buyer?category=${c.id}`}>{c.name}</FLink>)}
        </Col>
      </div>

      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col items-center gap-3 text-center">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-mx.png" alt="MaterialXpress" className="h-7 w-7 rounded-md" />
            <span className="font-display font-extrabold text-base text-slate-900">Material<span className="text-primary">Xpress</span></span>
          </Link>
          <p className="text-sm font-semibold text-slate-700">Building Connections. Delivering Value.</p>
          <p className="text-xs text-slate-500">
            Bengaluru · Peenya · Indiranagar · Whitefield · Electronic City · Jigani · procurement@materialxpress.in · +91 90000 00000
          </p>
          <p className="text-xs text-slate-400">© 2026 MaterialXpress Bengaluru · GST-compliant B2B sourcing</p>
        </div>
      </div>
    </footer>
  );
}
